export default "__VITE_ASSET__Dt6x5cKS__"